import React from 'react';
import { InfoPerksContext } from '../../../../../contexts';
import { ProXtraMobileAnnualization } from './PerkProgressSpend/ProXtraMobileAnnualization/ProXtraMobileAnnualization';
import { PerkProgressSpend } from './PerkProgressSpend/PerkProgressSpend';
import { TrackerDotTooltip } from '../../commons/TrackerUtils';
var choosePerkActivate = function () {
    console.log('TODO: choosePerkActivate()..');
};
var hideSpinner = function () {
    console.log('TODO: hideSpinner()..');
};
var showSpinner = function () {
    console.log('TODO: showSpinner()..');
};
var RenderPerkProgressMobile = function (props) {
    var perksInfo = props.perksInfo;
    return perksInfo ? (React.createElement("div", { className: "" },
        React.createElement(ProXtraMobileAnnualization, { choosePerkActivate: choosePerkActivate, hideSpinner: hideSpinner, showSpinner: showSpinner }))) : (React.createElement(React.Fragment, null));
};
var RenderPerkProgress = function (props) {
    var perksInfo = props.perksInfo, isMobile = props.isMobile;
    return perksInfo ? (React.createElement("div", { className: "perkProgressSpend__optionsZIndex" },
        React.createElement(PerkProgressSpend, { choosePerkActivate: choosePerkActivate, hideSpinner: hideSpinner, showSpinner: showSpinner, isMobile: isMobile }))) : (React.createElement(React.Fragment, null));
};
export var SpendTracker = React.memo(function (_a) {
    var isMobile = _a.isMobile;
    var _b = React.useContext(InfoPerksContext), perksInfo = _b.perksInfo, isLoading = _b.isLoading;
    if (isLoading)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { className: "PerkProgress__SpendTracker" },
        isMobile ? (React.createElement(RenderPerkProgressMobile, { perksInfo: perksInfo })) : (React.createElement(RenderPerkProgress, { perksInfo: perksInfo })),
        React.createElement(TrackerDotTooltip, null)));
});
